 
/* eslint-disable new-cap */
import ko from 'knockout';
import '../../../../jsscripts/jquery/knockout/knockout.mapping';

var opts = Object.prototype.toString;
var cdProfileCookie = smartPak.cdProfileCookie;

const TAXEXEMPT_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256,0C114.615,0,0,114.615,0,256s114.615,256,256,256,256-114.615,256-256S397.384,0,256,0ZM72.294,111.748l70.582,70.582c-3.181,30.154,10.739,56.982,36.552,73.529,18.053,11.569,41.464,18.793,61.53,24.554l60.326,60.326c-1.142.633-2.332,1.211-3.576,1.708-12.592,5.094-31.834,7.216-55.886,3.679-11.46-1.839-31.693-8.206-48.812-13.724-10.328-3.254-20.657-6.508-30.985-9.762-3.113-.99-6.225-1.981-9.338-2.971l-18.252,58.292c3.254.99,6.367,1.981,9.621,2.971,9.338,2.83,18.534,5.801,27.872,8.772,14.007,4.528,35.23,11.319,51.783,14.997v55.038h61.263v-52.066c12.592-1.415,24.618-4.245,35.654-8.772,8.847-3.596,17.199-8.321,24.621-14.195l55.001,55.001c-39.714,31.187-89.821,49.83-144.252,49.83-128.931,0-233.535-104.604-233.535-233.535,0-54.431,18.643-104.538,49.83-144.252ZM439.705,400.252l-64.724-64.724c6.027-32.776-6.849-63.282-34.261-82.075-21.081-14.431-49.237-22.496-71.308-28.721l-1.132-.283c-2.097-.597-4.129-1.179-6.131-1.753l-47.933-47.933c2.19-1.579,4.629-2.966,7.232-4.078,13.017-5.659,32.4-8.348,55.603-4.952,23.487,3.537,46.407,9.197,69.469,14.997l14.856-59.282c-25.326-6.367-50.652-12.592-76.543-16.271h-.141v-52.915h-61.121v54.189c-9.196,1.839-18.11,4.527-26.316,8.065-9.594,4.127-18.799,9.597-26.837,16.45l-58.671-58.671c39.714-31.187,89.821-49.83,144.252-49.83,128.931,0,233.535,104.604,233.535,233.535,0,54.431-18.643,104.538-49.83,144.252Z" style="stroke-width:0px;"></path></svg>';

function isObject(value) {
    return opts.call(value) === '[object Object]';
}

function formatModel(modelData) {
    Object.keys(modelData).forEach(function(key) {
        var value = modelData[key];

        if (isObject(value)) {
            modelData[key] = formatModel(value);
            return;
        }

        if (typeof value === 'number') {
            modelData[key] = '$' + value.toFixed(2);
        }
    });

    return modelData;
}

function formatDiscounts(discounts) {
    return !discounts
        ? []
        : Object.keys(discounts).map(function(key) {
                return {
                    name: key,
                    value: discounts[key]
                };
            });
}

function showTaxExemptMessaging(isTaxExempt){
    const taxMessaging = document.getElementById('tax-info');
    if(isTaxExempt && taxMessaging){
        taxMessaging.innerHTML = `Tax Exempt <span class="icon">` + TAXEXEMPT_SVG + `</span>`;
        taxMessaging.classList.remove('note');
    }
}

function CostSummaryViewModel(modelData) {
    ko.mapping.fromJS(formatModel(modelData), {}, this);

    this.Discounts = ko.observable(ko.toJS(this.Discounts));
    this.OrderDiscounts = ko.observable(ko.toJS(this.OrderDiscounts));
    this.orderDiscounts = ko.observableArray(formatDiscounts(this.OrderDiscounts()));
    this.discounts = ko.observableArray(formatDiscounts(this.Discounts()));
    this.itemsDiscounts = ko.computed(
        function() {
            return formatDiscounts(itemLevelDiscounts(this.Discounts(), this.OrderDiscounts()));
        }.bind(this)
    );
    
    this.orderTotal = ko.observable(absolutePrice(this.OrderTotal()));

    this.hasFreeShipping = ko.observable(this.IsFreeShipping());

    this.processingFeeEnabled = smartPak.pageData && smartPak.pageData.processingFeeEnabled;

    this.itemsDiscountMessage = ko.computed(
        function() {
            return this.itemsDiscounts()
                .map(function(discount) {
                    return discount.name;
                })
                .join(', ');
        }.bind(this)
    );

    this.itemsDiscountSum = ko.computed(
        function() {
            return '$' + (dollarToNumber(this.DiscountSum()) - dollarToNumber(this.OrderDiscountSum())).toFixed(2);
        }.bind(this)
    );

    this.discountMessage = ko.computed(
        function() {
            return this.discounts()
                .map(function(discount) {
                    return discount.name;
                })
                .join(', ');
        }.bind(this)
    );

    this.hasSavings = ko.computed(
        function() {
            return this.DiscountSum() !== '$0.00';
        }.bind(this)
    );

    this.hasCredits = ko.computed(() => {
        var credits = this.Credits();
        return credits && credits !== '$0.00';
    });

    this.hasGiftCertificates = ko.computed(() => {
        var giftCertificates = this.GiftCertificatesAmount();
        return giftCertificates && giftCertificates !== '$0.00';
    });

    this.hasProcessingFees = ko.computed(() => {
        var fees = this.ProcessingFee();
        return fees && fees !== '$0.00';
    });

    showTaxExemptMessaging(cdProfileCookie.IsTaxExempt);
}

CostSummaryViewModel.prototype.update = function(modelData) {
    var model = formatModel(modelData),
        name;

    for (name in model) {
        if (typeof this[name] === 'function') {
            this[name](model[name]);

            if (name === 'OrderTotal') {
                this.orderTotal(absolutePrice(model[name]));
            }

            if (name === 'IsFreeShipping') {
                this.hasFreeShipping(model[name]);
            }

            if (name === 'OrderDiscounts') {
                this.orderDiscounts(formatDiscounts(model[name]));
            }

            if (name === 'Discounts') {
                this.discounts(formatDiscounts(model[name]));
            }
        } else {
            this[name] = model[name];
        }
    }
    showTaxExemptMessaging(cdProfileCookie.IsTaxExempt);
};

function absolutePrice(str) {
    return '$' + Math.abs(dollarToNumber(str)).toFixed(2);
}

function dollarToNumber(str) {
    return +str.substring(1);
}

function itemLevelDiscounts(allDiscounts, orderDiscounts) {
    return !allDiscounts
        ? {}
        : Object.keys(allDiscounts).reduce(function(itemDiscounts, key) {
                if (orderDiscounts && !orderDiscounts[key]) {
                    itemDiscounts[key] = allDiscounts[key];
                }

                return itemDiscounts;
            }, {});
}

export default CostSummaryViewModel;
